import { icon } from "./icons";




// import components
// optimzation using lazy loading

// const SubProducts = lazy(() => import("../pages/Products/SubProducts"));
import Dashboard from "../pages/Dashboard";
import Products from "../pages/Products";
import SubProducts from "../pages/Products/SubProducts";

import AddProduct from "../pages/Products/AddProduct";
import AutoProductList from "../pages/Products/AutoProductList";

import AddSubProduct from "../pages/Products/AddSubProduct";
import EditSubProduct from "../pages/Products/EditSubProduct";

import EditProduct from "../pages/Products/EditProduct";
import Orders from "../pages/Orders";

import InProgressOrders from "../pages/Orders/InProgressOrders";
import OrderLog from "../pages/Orders/OrderLog";
import AddNote from "../pages/Orders/AddNote";

import EditOrder from "../pages/Orders/EditOrder";

import Users from "../pages/Users";
import AddUser from "../pages/Users/AddUser";
import EditUser from "../pages/Users/EditUser";
import Balance from "../pages/Users/Balance";
import BalanceHistory from "../pages/BalanceHistory";
import UserOrders from "../pages/Users/Orders";
import Transactions from "../pages/Users/Transactions";

import Categories from "../pages/Categories";
import AddCategory from "../pages/Categories/AddCategory";
import EditCategory from "../pages/Categories/EditCategory";

import PopupMessage from "../pages/PopupMessage";
import ImageManager from "../pages/ImageManager";
import AddPopup from "../pages/PopupMessage/AddPopup";
import ViewPopup from "../pages/PopupMessage/ViewPopup";

import About from "../pages/About";
import Payment from "../pages/PaymentInfo/Payment";
import AddPayment from "../pages/PaymentInfo/AddPayment";
import EditPayment from "../pages/PaymentInfo/EditPayment";

import Ads from "../pages/Ads";
import AddAds from "../pages/Ads/AddAds";
import Banner from "../pages/Ads/Banner";

import EditAds from "../pages/Ads/EditAds";
import Profile from "../pages/Profile";
import AddImage from "../pages/ImageManager/AddImage";

import RequestedBalance from "../pages/RequestedBalance";
import EditRequestedBalance from "../pages/RequestedBalance/EditRequestedBalance";


import CustomPrices from "../pages/CustomPrices";
import AddCustomPrice from "../pages/CustomPrices/AddCustomPrice";
import EditCustomPrice from "../pages/CustomPrices/EditCustomPrice";
import TelegramAccount from "../pages/TelegramAccount";

// const Dashboard = lazy(() => import("../pages/Dashboard"));
// const Products = lazy(() => import("../pages/Products"));
// const SubProducts = lazy(() => import("../pages/Products/SubProducts"));

// const AddProduct = lazy(() => import("../pages/Products/AddProduct"));
// const AutoProductList = lazy(() => import("../pages/Products/AutoProductList"));

// const AddSubProduct = lazy(() => import("../pages/Products/AddSubProduct"));
// const EditSubProduct = lazy(() => import("../pages/Products/EditSubProduct"));

// const EditProduct = lazy(() => import("../pages/Products/EditProduct"));
// const Orders = lazy(() => import("../pages/Orders"));

// const InProgressOrders = lazy(() => import("../pages/Orders/InProgressOrders"));
// const OrderLog = lazy(() => import("../pages/Orders/OrderLog"));
// //const AddNote = lazy(() => import("../pages/Orders/AddNote"));

// const EditOrder = lazy(() => import("../pages/Orders/EditOrder"));

// const Users = lazy(() => import("../pages/Users"));
// const AddUser = lazy(() => import("../pages/Users/AddUser"));
// const EditUser = lazy(() => import("../pages/Users/EditUser"));
// const Balance = lazy(() => import("../pages/Users/Balance"));
// //const UserOrders = lazy(() => import("../pages/Users/Orders"));

// const BalanceHistory = lazy(() => import("../pages/BalanceHistory"));

// const Categories = lazy(() => import("../pages/Categories"));
// const AddCategory = lazy(() => import("../pages/Categories/AddCategory"));
// const EditCategory = lazy(() => import("../pages/Categories/EditCategory"));
// const About = lazy(() => import("../pages/About"));
// const Payment = lazy(() => import("../pages/PaymentInfo/Payment"));
// const AddPayment = lazy(() => import("../pages/PaymentInfo/AddPayment"));
// const EditPayment = lazy(() => import("../pages/PaymentInfo/EditPayment"));

// const Ads = lazy(() => import("../pages/Ads"));
// const AddAds = lazy(() => import("../pages/Ads/AddAds"));
// const Banner = lazy(() => import("../pages/Ads/Banner"));

// const EditAds = lazy(() => import("../pages/Ads/EditAds"));
// const Profile = lazy(() => import("../pages/Profile"));

export const routes = [
  {
    id: 1,
    name: "لوحة التحكم",
    icon: icon.dashboard,
    path: "/",
    type: ["route"],
    index: true,
    element: <Dashboard title="لوحة التحكم" />,
  },
  {
    id: 2,
    name: "التحويلات المالية",
    icon: icon.dollar,
    path: "/balance-history",
    type: ["route", "collapse"],
    element: <BalanceHistory title="التحويلات المالية" />,
  },
  {
    id: 3,
    name: "المنتجات",
    icon: icon.products,
    children: [
      {
        id: 1,
        name: "كل المنتجات",
        icon: icon.products,
        path: "/products",
        type: ["route", "collapse"],
        element: <Products title="كل المنتجات" />,
      },
      {
        id: 2,
        name: "الباقات",
        icon: icon.products,
        path: "/products/:id",
        type: ["route"],
        element: <SubProducts title="الباقات" />,
      },
      {
        id: 3,
        name: "إضافة منتج",
        icon: icon.addProduct,
        path: "/products/add",
        type: ["route", "collapse"],
        element: <AddProduct title="إضافة منتج" />,
      },
      {
        id: 4,
        name: "تعديل منتج",
        path: "/products/edit/:id",
        type: ["route"],
        element: <EditProduct title="تعديل منتج" />,
      },
      {
        id: 5,
        name: "اضافة باقة",
        path: "/products/:id/sub-product",
        type: ["route"],
        element: <AddSubProduct title="اضافة باقة" />,
      },
      {
        id: 5,
        name: "تعديل الباقة",
        path: "/products/:id/sub-product/:subId",
        type: ["route"],
        element: <EditSubProduct title="تعديل الباقة" />,
      },
      {
        id: 6,
        name: "المنتجات الآلية",
        icon: icon.products,
        path: "/products/auto-list",
        type: ["route", "collapse"],
        element: <AutoProductList title="المنتجات الآلية" />,
      },
    ],
  },
  {
    id: 4,
    name: "الطلبات",
    icon: icon.orders,
    children: [
      {
        id: 1,
        name: "كل الطلبات",
        icon: icon.ordersAll,
        path: "/orders",
        type: ["route", "collapse"],
        element: <Orders title="كل الطلبات" />,
      },
      {
        id: 2,
        name: "في الانتظار",
        icon: icon.archiveOrders,
        path: "/orders/in-progress",
        type: ["route", "collapse"],
        element: <InProgressOrders title="في الانتظار" />,
      },
      {
        id: 3,
        name: "تعديل حالة الطلب",
        icon: icon.archiveOrders,
        path: "/orders/edit/:id",
        type: ["route"],
        element: <EditOrder title="تعديل حالة الطلب" />,
      },
      {
        id: 4,
        name: "تتبع الطلب الآلي",
        icon: icon.archiveOrders,
        path: "/orders/log",
        type: ["route", "collapse"],
        element: <OrderLog title="تتبع الطلب الآلي" />,
      },
      {
        id: 5,
        name: "اضافة ملاحظة",
        icon: icon.archiveOrders,
        path: "/orders/:orderId/note",
        type: ["route"],
        element: <AddNote title="اضافة ملاحظة" />,
      },
    ],
  },
  {
    id: 5,
    name: "المستخدمين",
    icon: icon.users,
    children: [
      {
        id: 1,
        name: "كل المستخدمين",
        icon: icon.users,
        path: "/users",
        type: ["route", "collapse"],
        element: <Users title="كل المستخدمين" />,
      },
      {
        id: 2,
        name: "إضافة مستخدم",
        icon: icon.addUser,
        path: "/users/add",
        type: ["route", "collapse"],
        element: <AddUser title="إضافة مستخدم" />,
      },
      {
        id: 3,
        name: "شحن/سحب رصيد",
        path: "/users/balance",
        icon: icon.dollar,
        type: ["route", "collapse"],
        element: <Balance title="شحن/سحب رصيد" />,
      },
      {
        id: 4,
        name: "تعديل مستخدم",
        path: "/users/edit/:id",
        type: ["route"],
        element: <EditUser title="تعديل مستخدم" />,
      },
      {
        id: 5,
        name: "طلبات المستخدم",
        path: "/users/orders/:id",
        type: ["route"],
        element: <UserOrders title="طلبات المستخدم" />,
      },
      {
        id: 6,
        name: "التقارير المالية",
        path: "/users/:id/transactions",
        type: ["route"],
        element: <Transactions title="التقارير المالية" />,
      },
      {
        id: 7,
        name: "كل الأسعار المخصصة",
        icon: icon.popup,
        path: "/subitems/:id/custom-prices",
        type: ["route"],
        element: <CustomPrices title="كل الاسعار المخصصة " />,
      },
      {
        id: 8,
        name: "إضافة سعر مخصص",
        icon: icon.popup,
        path: "/subitems/:id/custom-prices/add",
        type: ["route"],
        element: <AddCustomPrice title="إضافة سعر مخصص"/>,

      },
      {
        id: 9,
        name: "تعديل سعر مخصص",
        icon: icon.popup,
        path: "/custom-prices/edit/:id",
        type: ["route"],
        element: <EditCustomPrice title="تعديل سعر مخصص"/>,

      },
    ],
  },

  {
    id: 10,
    name: "الأقسام",
    icon: icon.products,
    children: [
      {
        id: 1,
        name: "كل الأقسام",
        icon: icon.products,
        path: "/categories",
        type: ["route", "collapse"],
        element: <Categories title="كل الأقسام" />,
      },
      {
        id: 2,
        name: "إضافة قسم",
        icon: icon.addProduct,
        path: "/categories/add",
        type: ["route", "collapse"],
        element: <AddCategory title="إضافة قسم" />,
      },
      {
        id: 3,
        name: "تعديل القسم",
        path: "/categories/edit/:id",
        type: ["route"],
        element: <EditCategory title="تعديل قسم" />,
      },
    ],
  },

  {
    id: 6,
    name: "الاعلانات",
    icon: icon.ads,
    children: [
      {
        id: 1,
        name: "الاعلانات",
        icon: icon.info,
        path: "/ads",
        type: ["route", "collapse"],
        element: <Ads title="الاعلانات" />,
      },
      {
        id: 2,
        name: "إضافة اعلان",
        icon: icon.info,
        path: "/ads/add",
        type: ["route", "collapse"],
        element: <AddAds title="إضافة اعلان" />,
      },
      {
        id: 3,
        name: "تعديل اعلان",
        icon: icon.info,
        path: "/ads/edit/:id",
        type: ["route"],
        element: <EditAds title="تعديل اعلان" />,
      },
      {
        id: 4,
        name: "اضافة شريط اعلاني",
        icon: icon.info,
        path: "/ads/add-banner",
        type: ["route", "collapse"],
        element: <Banner title="اضافة شريط اعلاني" />,
      },
    ],
  },

  {
    id: 8,
    name: "معلومات الدفع",
    icon: icon.dollar,
    children: [
      {
        id: 1,
        name: "معلومات الدفع",
        icon: icon.dollar,
        path: "/payment-info",
        type: ["route", "collapse"],
        element: <Payment title="معلومات الدفع" />,
      },
      {
        id: 2,
        name: "إضافة الدفع",
        icon: icon.dollar,
        path: "/add-payment-info",
        type: ["route", "collapse"],
        element: <AddPayment title="إضافة الدفع" />,
      },
      {
        id: 3,
        name: "تعديل معلومات الدفع",
        icon: icon.dollar,
        path: "/payment-info/:id",
        type: ["route"],
        element: <EditPayment title="تعديل معلومات الدفع" />,
      },
    ],
  },
  {
    id: 13,
    name: "طلبات الرصيد",
    icon: icon.dollar,
    children: [
      {
        id: 1,
        name: "طلبات الرصيد",
        icon: icon.dollar,
        path: "/balance-requested",
        type: ["route", "collapse"],
        element: <RequestedBalance title="طلبات الرصيد" />,
      },
      {
        id: 2,
        name: "تعديل طلب الرصيد",
        path: "/balance-requested/:id",
        type: ["route"],
        element: <EditRequestedBalance title="تعديل طلب الرصيد" />,
      },
    ],
  },
  {
    id: 12,
    name: "إدارة الصور",
    icon: icon.FaImages,
    children: [
      {
        id: 1,
        name: "كل الصور ",
        icon: icon.FaImages,
        path: "/images-manger",
        type: ["route", "collapse"],
        element: <ImageManager title="كل الصور " />,
      },
      {
        id: 2,
        name: "إضافة صورة ",
        icon: icon.addImage,
        path: "/images-manger/add",
        type: ["route", "collapse"],
        element: <AddImage title="إضافة صورة" />,
      },
    ],
  },
  {
    id: 11,
    name: "الرسائل المنبثقة",
    icon: icon.popup,
    children: [
      {
        id: 1,
        name: "كل الرسائل المنبثقة",
        icon: icon.popup,
        path: "/popup-messages",
        type: ["route", "collapse"],
        element: <PopupMessage title="كل الرسائل المنبثقة" />,
      },
      {
        id: 2,
        name: "إضافة رسالة منبثقة",
        icon: icon.addPopup,
        path: "/popup-messages/add",
        type: ["route", "collapse"],
        element: <AddPopup title="إضافة رسالة منبثقة " />,
      },
      {
        id: 3,
        name: "تعديل الرسالة",
        path: "/popup-messages/view/:id",
        type: ["route"],
        element: <ViewPopup title="عرض رسالة منبثقة" />,
      },
    ],
  },

  // {
  //   id: 12,
  //   name: "الرسائل المنبثقة",
  //   icon: icon.popup,
  //   children: [
  //     {
  //       id: 1,
  //       name: "كل الرسائل المنبثقة",
  //       icon: icon.popup,
  //       path: "/subitems/:id/custom-prices",
  //       type: ["route"],
  //       element: <CustomPrices title="كل الاسعار المخصصة " />,
  //     },
  //     {
  //       id: 2,
  //       name: "إضافة رسالة منبثقة",
  //       icon: icon.addPopup,
  //       path: "/popup-messages/add",
  //       type: ["route", "collapse"],
  //       element: <AddPopup title="إضافة رسالة منبثقة " />,
  //     },
  //     {
  //       id: 3,
  //       name: "تعديل الرسالة",
  //       path: "/popup-messages/view/:id",
  //       type: ["route"],
  //       element: <ViewPopup title="عرض رسالة منبثقة" />,
  //     },
  //   ],
  // },


  {
    id: 7,
    name: "الملف الشخصي",
    icon: icon.user,
    path: "/profile",
    type: ["route"],
    element: <Profile title="الملف الشخصي" />,
  },
  {
    id: 14,
    name: "حساب التلغرام ",
    icon: icon.dashboard,
    path: "/telegram-account",
    type: ["route"],
    element: <TelegramAccount title="حساب التلغرام" />,
  },
  {
    id: 9,
    name: "من نحن",
    icon: icon.info,
    path: "/about",
    type: ["route"],
    element: <About title="من نحن" />,
  },
];
